<script>
    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }
    export let project=undefined;
    export let statistic=undefined;
    export let expanded = false;
    import {apiUrl} from '../config.svelte';
    import {Button,Nav, NavItem, NavLink,Label,Input,FormGroup} from 'sveltestrap';
    import {onMount,onDestroy} from 'svelte';
    let tab="Активности"
    let projectBefore = undefined;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    let filter={
        activities:[],
        date_from:(new Date()).addDays(-1).toJSON().substring(0,10),
        date_to:new Date().toJSON().substring(0,10),
        queues:[],
        admission:false,
        train:false,
    }
    $:{
        if(project!=projectBefore){
            fetch(apiUrl+"statistics",{
                credentials:'include',
                method:"POST",
                body:JSON.stringify({method:"activities",project:project}),
                cors:'no-cors'
            })
            .then(x=>x.json())
            .then(x=>{
                if(x.result){
                    filter.activities=[]
                    x.data.forEach(a=>{
                        filter.activities.push({name:a.ActivityStat,check:true})
                    })
                                    
                }
            })
            fetch(apiUrl+"info",{
                method:"POST",
                cors:'no-cors',
                credentials:'include',
                body:JSON.stringify({project:project,method:"queues"})
            })
            .then(x=>x.json())
            .then(x=>{
                if (x.result){
                    filter.queues=[]
                    x.data.forEach(e=>{
                        e.check=true;
                        filter.queues.push(e)
                    })
                }else{
                    filter.queues = []
                }
            })
            .catch(()=>{
                filter.queues = []
            })
            projectBefore=project
        }
        dispatch('change',{filter:filter})
    }
    
    


    function isEmpty(obj) {
		return Object.keys(obj).length === 0;
	}
    

    let filterBefore=undefined;
    $:{
        if (filterBefore!=filter){

            dispatch('change',{filter:filter})
            filterBefore=filter
        }
    }
    onMount(()=>{
        dispatch('change',{filter:filter})
    })
</script>

{#if !expanded}
    <Button on:click={()=>{if(!isEmpty(project)&&!isEmpty(statistic))expanded=true}} outline color="dark" block style="text-align:left;float:left"><img src="/img/filter-ico2.png" alt="filter" style="width:20px;height:20px;"/>
        {statistic.name?statistic.name:""}
    </Button>
{:else}
    <div style="postition:absolute;height:500px;border-radius:4px 4px 4px 4px;box-shadow: 0px 0px 2px black;width:calc(100% - 4px);margin:2px;">
        <Nav tabs>
            <NavItem>
                <NavLink disabled>{statistic.name}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="Активности"?true:false} on:click={()=>{tab="Активности"}}>Активности</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="Даты"?true:false} on:click={()=>{tab="Даты"}}>Даты</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="Куи"?true:false} on:click={()=>{tab="Куи"}}>Куи</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="Дополнительно"?true:false} on:click={()=>{tab="Дополнительно"}}>Дополнительно</NavLink>
            </NavItem>
                
        </Nav>
        <Button outline color="dark" style="position:absolute;right:148px;top:3px;" on:click={()=>{expanded=false;}}><img src="/img/min-box.png" style="width:20px;height:20px" alt="скрыть"/></Button>
        <div style="height:calc(100% - 40px);width:100%;box-shadow:0px 0px 1px black;overflow:auto">
            {#if tab=="Активности"}
                <div style="width:650px;margin-left:25px;">
                    <FormGroup check>
                        {#each filter.activities as activity}
                            <Label check>
                                <Input type="checkbox" id={activity.name+"-check"} bind:checked={activity.check}/>
                                {activity.name}
                            </Label>
                        {/each}
                    </FormGroup>
                </div>
            {:else if tab=="Даты"}
                <div style="width:300px;margin-left:15px">
                    <div style="float:left">
                        <Label for="date-from-input" style="float:top">от</Label>
                        <Input type="date" id="date-from-input" style="float:left;width:200px;" bind:value={filter.date_from}/>
                    </div>
                    <div style="float:left">
                        <Label for="date-to-input" style="float:top">до</Label>
                        <Input type="date" id="date-to-input" style="float:left;width:200px;" bind:value={filter.date_to}/>
                    </div>
                </div>
            {:else if tab=="Куи"}
                <div style="width:650px;margin-left:25px;">
                    <FormGroup check>
                        {#each filter.queues as queue}
                            <Label check>
                                <Input type="checkbox" id={queue.QueueNum+"-check"} bind:checked={queue.check}/>
                                {queue.QueueNum}
                            </Label>
                        {/each}
                    </FormGroup>
                </div>
            {:else if tab=="Дополнительно"}
                <div style="width:300px;margin-left:15px">
                    <FormGroup check>
                         <Label check>
                            <Input type="checkbox" id="train-check" bind:checked={filter.train}/>
                            треннинг
                        </Label>
                        <Label check>
                            <Input type="checkbox" id="admission-check" bind:checked={filter.admission}/>
                            учитывать допуск
                        </Label>
                    </FormGroup>
                </div>
            {/if}
        </div>
    </div>
{/if}